import type { SVGProps } from "react";
export interface MicrochipAIIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MicrochipAIIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MicrochipAIIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.875 22v-2a1.125 1.125 0 0 1 2.25 0v2a1.125 1.125 0 0 1-2.25 0m4 0v-2a1.125 1.125 0 0 1 2.25 0v2a1.125 1.125 0 0 1-2.25 0m4 0v-2a1.125 1.125 0 0 1 2.25 0v2a1.125 1.125 0 0 1-2.25 0M4 14.873a1.125 1.125 0 0 1 0 2.25H2a1.125 1.125 0 0 1 0-2.25zM8.226 8.14c.558-1.688 2.99-1.688 3.549 0l.048.174 1.771 7.424.02.113a1.124 1.124 0 0 1-2.176.52l-.032-.112-.39-1.635H8.984l-.39 1.635a1.125 1.125 0 0 1-2.188-.521l1.77-7.424zm6.648 7.858V8a1.125 1.125 0 0 1 2.25 0v8a1.125 1.125 0 0 1-2.25 0ZM22 14.874a1.125 1.125 0 0 1 0 2.25h-2a1.125 1.125 0 0 1 0-2.25zM4 10.877a1.125 1.125 0 0 1 0 2.25H2a1.125 1.125 0 0 1 0-2.25zm18 0 .115.005a1.125 1.125 0 0 1 0 2.239l-.115.006h-2a1.125 1.125 0 0 1 0-2.25zm-12.48 1.5h.959l-.48-2.009zM4 6.875l.115.006a1.125 1.125 0 0 1 0 2.238L4 9.125H2a1.125 1.125 0 0 1 0-2.25zm18 0a1.125 1.125 0 0 1 0 2.25h-2a1.125 1.125 0 0 1 0-2.25zM6.875 4V2a1.125 1.125 0 0 1 2.25 0v2a1.125 1.125 0 0 1-2.25 0m4 0V2a1.125 1.125 0 0 1 2.25 0v2a1.125 1.125 0 0 1-2.25 0m4 0V2a1.125 1.125 0 0 1 2.25 0v2a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M18.875 7.83a.88.88 0 0 0-.148-.487l-.108-.134-1.828-1.828a.88.88 0 0 0-.62-.256H7.83a.88.88 0 0 0-.62.256L5.381 7.21a.88.88 0 0 0-.256.62v8.342c0 .233.092.456.256.62l1.828 1.828.134.108a.88.88 0 0 0 .486.148h8.342a.88.88 0 0 0 .62-.256l1.828-1.828a.88.88 0 0 0 .256-.62zm2.25 8.341c0 .83-.329 1.625-.915 2.21l-1.828 1.829a3.13 3.13 0 0 1-2.21.915H7.828a3.13 3.13 0 0 1-1.98-.707l-.23-.208-1.828-1.828a3.13 3.13 0 0 1-.916-2.21V7.828c0-.829.33-1.624.916-2.21L5.619 3.79l.23-.208a3.13 3.13 0 0 1 1.98-.708h8.342c.83 0 1.625.33 2.21.916l1.829 1.828.208.23c.455.556.707 1.255.707 1.98z"
      />
    </svg>
  );
}
